
const util = require('util');

const _ = require('lodash');

const vb = require('../definition');

const {
	unwrap,
} = require('../util');

vb.everyFileHasExtension = (ext, message) => {
	return {
		validator: v => {
			const extension = unwrap(ext).toLowerCase();
			return _.every(v, f => {
				const file = unwrap(f);
				const fileName = file && file.Name();
				return !fileName
					|| String(fileName).toLowerCase().endsWith(`.${extension}`);
			});
		},
		message: () => {
			const extension = unwrap(ext).toLowerCase();
			return message || util.format('только %s файлы', extension);
		},
	};
};